import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { GuideService } from '../../../services/resources/guide.service';
import { LanguageMap } from '../../../core/languages';
import { SimpleCheckModalComponent } from '../../../common/modals/simple-check-modal.component';
import { GuideDetailInterface, newGuideInterface } from '../../../core/models';
import { take } from 'rxjs';
import { at } from 'lodash';
import { SimpleLoadingModalComponent } from '../../../common/modals/simple-loading-modal.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-resources-dashboard',
  imports: [
    CommonModule,
    RouterModule,
    SimpleCheckModalComponent,
    SimpleLoadingModalComponent,
  ],
  standalone: true,
  template: `
    <div class="mx-auto max-w-7xl  pt-6 px-4 sm:px-6 lg:px-8">
      <div class="px-4 sm:px-6 lg:px-8">
        <div class="sm:flex sm:items-center pt-6">
          <div class="sm:flex-auto">
            <h1 class="text-base font-semibold leading-6 text-gray-900">
              Guides
            </h1>
            <p class="mt-2 text-sm text-gray-700">
              A list of all the Guides for booking.
            </p>
          </div>
          <div class="mt-4 sm:mt-0 sm:ml-16 sm:flex-none space-x-4">
            <button
              type="button"
              routerLink="/resources/new"
              class="justify-center disabled:opacity-25 rounded-md bg-columbus-blue-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-columbus-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-columbus-blue-600"
            >
              Create new Guide
            </button>
            <button
              (click)="toggleResetModal()"
              type="button"
              class="justify-center disabled:opacity-25 rounded-md bg-columbus-blue-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-columbus-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-columbus-blue-600"
            >
              Reset T&C's
            </button>
          </div>
        </div>
        <div class="mt-8 flow-root">
          <div class="-mx-4 -my-2  sm:-mx-6 lg:-mx-8">
            <div
              class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8"
              *ngIf="guides.length > 0"
            >
              <table class="min-w-full   divide-y divide-gray-300">
                <thead>
                  <tr>
                    <th
                      scope="col"
                      class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0"
                    >
                      ID - Identifier
                    </th>
                    <th
                      scope="col"
                      class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0"
                    >
                      Forename
                    </th>
                    <th
                      scope="col"
                      class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      <div
                        class="flex flex-row w-fit items-center justify-start "
                      >
                        Surname
                        <span class="pl-2">
                          <div
                            (click)="resort()"
                            class="p-0.5  rounded-md cursor-pointer text-bold text-black hover:ring-2 hover:ring-columbus-blue-800 hover:bg-columbus-blue-600 hover:text-white"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke-width="1.5"
                              stroke="currentColor"
                              class="size-[18px] "
                              [ngClass]="sortDir ? 'rotate-180' : 'rotate-0'"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="m19.5 8.25-7.5 7.5-7.5-7.5"
                              />
                            </svg>
                          </div>
                        </span>
                      </div>
                    </th>
                    <th
                      scope="col"
                      class=" px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Email
                    </th>
                    <th
                      scope="col"
                      class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Tel.
                    </th>
                    <th
                      scope="col"
                      class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Languages
                    </th>
                    <th
                      scope="col"
                      class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      T&C
                    </th>
                    <th
                      scope="col"
                      class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Edit
                      <span class="sr-only">Edit</span>
                    </th>
                  </tr>
                </thead>
                <tbody class="divide-y divide-gray-200">
                  @for (guide of guides; track guide.id) {
                    <tr>
                      <td
                        class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-light text-gray-600 italic sm:pl-0"
                      >
                        {{ guide.id }}
                      </td>
                      <td
                        class="whitespace-nowrap py-4 pl-4 pr-3 text-sm text-gray-500 sm:pl-0"
                      >
                        {{ guide.forename }}
                      </td>
                      <td
                        class=" px-3 py-4 text-sm font-medium  text-gray-900 max-w-[10rem]"
                      >
                        <span class="block w-full truncate">
                          {{ guide.surname }}
                        </span>
                      </td>
                      <td class="px-3 py-4 text-sm text-gray-500 max-w-[10rem]">
                        <span class="block w-full truncate">
                          {{ guide.email }}
                        </span>
                      </td>
                      <td
                        class="whitespace-nowrap px-3 py-4 text-sm text-gray-500"
                      >
                        {{ guide.tel }}
                      </td>
                      <td
                        class="whitespace-nowrap px-3 py-4 text-sm text-gray-500"
                      >
                        {{ languageCodes(guide.languages) }}
                      </td>
                      <td
                        class="whitespace-nowrap px-3 py-4 text-sm text-gray-500"
                      >
                        @if (guide.tAndC) {
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                            class="size-6 stroke-green-600"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                            />
                          </svg>
                        } @else {
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                            class="size-6 stroke-red-600"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                            />
                          </svg>
                        }
                      </td>
                      <td
                        class="whitespace-nowrap px-3 py-4 text-sm text-gray-500"
                      >
                        <div class="flex flex-row justify-around space-x-4">
                          <div
                            routerLink="/resources/{{ guide.id }}"
                            class="text-columbus-blue-600 hover:text-columbus-blue-900 hover:cursor-pointer"
                          >
                            Edit<span class="sr-only">Edit</span>
                          </div>
                          <div
                            (click)="onDelete(guide)"
                            class="text-red-600 hover:text-red-900 hover:cursor-pointer"
                          >
                            Delete<span class="sr-only">Delete</span>
                          </div>
                        </div>
                      </td>
                    </tr>
                  }

                  <!-- More people... -->
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="onDeleteToggle && selectedGuide">
      <app-simple-check-modal
        [title]="
          'Delete Guide ' + selectedGuide.forename + ' ' + selectedGuide.surname
        "
        [message]="'Do you want to delete the guide?'"
        [positiveButtonText]="'Yes'"
        [negativeButtonText]="'No'"
        (close)="onCloseDeleteModal($event)"
      ></app-simple-check-modal>
    </div>
    <div *ngIf="onResetToggle">
      <app-simple-check-modal
        [title]="'RESET T&C'"
        [message]="'Do you want to reset all T&Cs?'"
        [positiveButtonText]="'Yes'"
        [negativeButtonText]="'No'"
        (close)="onResetTandCModal($event)"
      ></app-simple-check-modal>
    </div>

    <div *ngIf="resetLoadingToggler">
      <app-simple-loading-modal
        [title]="'Reseting Guides...'"
      ></app-simple-loading-modal>
    </div>
  `,
  styles: ``,
})
export class ResourcesDashboardComponent implements OnInit {
  guideServices = inject(GuideService);
  guides$ = this.guideServices.getGuides();

  private readonly destroyRef = inject(DestroyRef);
  guides: GuideDetailInterface[] = [];

  sortDir: boolean = false;

  languageOptions = Object.entries(LanguageMap).map(([key, value]) => ({
    code: key,
    name: value,
  }));

  onDeleteToggle = false;
  selectedGuide: GuideDetailInterface | undefined = undefined;

  onResetToggle = false;
  resetLoadingToggler = false;

  constructor() {
    this.guides$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((guides) => {
        if (!guides) return;
        this.guides = guides;
      });
  }
  ngOnInit(): void {}

  languageCodes(langCodes: Record<string, boolean>) {
    let textCodes = '';

    Object.entries(langCodes).forEach((lang) => {
      textCodes += (lang.at(0) as string).toUpperCase() + ' ';
    });

    return textCodes;
  }

  toggleDeleteModal() {
    this.onDeleteToggle = !this.onDeleteToggle;
  }

  onDelete(guide: GuideDetailInterface) {
    this.selectedGuide = guide;
    this.toggleDeleteModal();
  }

  onCloseDeleteModal(value: boolean) {
    if (value && this.selectedGuide) {
      this.guideServices.deleteGuide(this.selectedGuide.id);
    }

    this.toggleDeleteModal();
  }

  toggleResetModal() {
    this.onResetToggle = !this.onResetToggle;
  }

  onResetTandCModal(value: boolean) {
    if (value) {
      this.resetLoadingToggler = true;
      const resetGuides = this.guides.filter((guide) => guide.tAndC === true);

      this.guideServices
        .resetTandC(resetGuides)
        .then(() => console.log('Success'))
        .catch((err) => console.error('Error', err))
        .finally(() => {
          this.resetLoadingToggler = false;
        });
    }

    this.toggleResetModal();
  }

  resort() {
    const dir = this.sortDir ? 1 : -1;
    this.guides.sort((a, b) => {
      return dir * a.surname.localeCompare(b.surname);
    });

    this.sortDir = !this.sortDir;
  }
}
